export default __webpack_public_path__ + "static/media/upload_image.1028cb6b.svg";